import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';
import { TRELLO, MONDAY, type SupportedThirdParty } from '../../../common/constants/import-type';
import { useContentForThirdParty } from '../../../common/utils';
import { useThirdPartyState } from '../../../controllers/import-state';
import { Card } from './card';

type Props = {
	thirdParty: SupportedThirdParty;
};
export const ProjectCreateStats = ({ thirdParty }: Props) => {
	const [{ entityStats, userEmails }] = useThirdPartyState();
	const { cardStatsShort, usersStatsShort } = useContentForThirdParty(thirdParty);

	if (thirdParty !== TRELLO && thirdParty !== MONDAY) {
		return null;
	}

	const tasks = fg('jwm_clickup_importer') ? entityStats?.tasksCount : entityStats?.tasks;
	return (
		<Wrapper data-testid="project-create-importer-upload-flow.ui.project-create-screen.project-create-stats.wrapper">
			{entityStats?.members != null && (
				<Card
					cardContent={usersStatsShort}
					statistic={thirdParty === TRELLO ? Object.keys(userEmails).length : entityStats.members}
				/>
			)}
			{tasks != null && <Card cardContent={cardStatsShort} statistic={tasks} />}
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	flexDirection: 'row',
	margin: `${token('space.400', '32px')} 0 ${token('space.100', '8px')}`,
});
